module.exports = __webpack_public_path__ + "img/12-labours-logo-white.77f1c6d1.png";